import validate from "/usr/src/app/content/n3-spas-ae75b7aa-cb67-4715-be29-3b8bf20a588a/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-spas-ae75b7aa-cb67-4715-be29-3b8bf20a588a/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}